<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-check-circle-o fa-lg icon-button"
                title="Comprometer"
                @click.stop="confirmarComprometer()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarComprometer() {
            this.$swal({
                title: 'Comprometimento',
                html: `Confirma a realização do comprometimento do id ${this.comprometimento.idComprometimento} do 
                contrato ${this.contrato.vcCodigoEstruturado} no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.comprometer()
                }
            })
        },

        comprometer() {
            this.$emit('comprometer', this.comprometimento.idComprometimento)
        }
    }
}
</script>
